let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("h42Kg")).then(() => parcelRequire('ciROb'));